const EntryService = require('../services/EntryService').default;
const entryCreate = require('./contentful/entry-create');
const entryUpdate = require('./contentful/entry-update');
const getSpace = require('./contentful/get-space');
const transformer = require('./transformers/giftcard');
const linkResolve = require('./contentful/link-resolve');
const processError = require('./contentful/error-process');

let entryService = null;

const gettingEntryService = () => {
  if (!entryService) {
    entryService = getSpace().then((space) => {
      return new EntryService(space, transformer);
    });
  }

  return entryService;
};


const createGiftcard = (space, giftcard, depth) => {
  const data = transformer.internalToContentful(giftcard);
  return entryCreate(space, 'giftcard', data).then((entry) => {
    const data = entry.toPlainObject();
    return linkResolve(space, data, depth);
  }).then((data) => {
    return transformer.contentfulToInternal(data);
  });
};

const updateGiftcard = (space, giftcard, depth) => {
  return space.getEntry(giftcard.id).catch(
    processError
  ).then((entry) => {
    const data = transformer.internalToContentful(giftcard);
    return entryUpdate(entry, data).then((entry) => {
      const data = entry.toPlainObject();
      return linkResolve(space, data, depth);
    }).then((data) => {
      return transformer.contentfulToInternal(data);
    });
  });
};

module.exports = {
  getById(...parameters) {
    return gettingEntryService().then((service) => service.getById(...parameters));
  },

  publish(...parameters) {
    return gettingEntryService().then((service) => service.publish(...parameters));
  },

  unpublish(...parameters) {
    return gettingEntryService().then((service) => service.unpublish(...parameters));
  },

  archive(...parameters) {
    return gettingEntryService().then((service) => service.archive(...parameters));
  },

  unarchive(...parameters) {
    return gettingEntryService().then((service) => service.unarchive(...parameters));
  },

  getAll(depth = 0, params) {
    const entryParams = {
      content_type: 'giftcard',
      order: '-sys.createdAt',
      limit: 999
    };

    if (params.makeId) {
      entryParams['fields.makes.sys.id'] = params.makeId;
    }

    return getSpace().then((space) => {
      return space.getEntries(entryParams).catch(
        processError
      ).then((response) => {
        const data = response.toPlainObject();
        return linkResolve(space, data, depth);
      }).then((data) => {
        return data.items.map(transformer.contentfulToInternal);
      });
    });
  },

  save(giftcard, depth = 0) {
    return getSpace().then((space) => {
      if (!giftcard.id) {
        return createGiftcard(space, giftcard, depth);
      }
      return updateGiftcard(space, giftcard, depth);
    });
  },

  createEmpty() {
    return {
      published: false,
      updated: false,
      draft: true,
      modelNames: [],

      id: null
    };
  }
};
